export const NO_PROGRESS_TEST_RESULTS_WITHIN_IDP_PERIOD_MESSAGE =
  'No progress test results were found within the IDP period. Please verify whether the IDP period is correct.';

export function isNoProgressTestResultsWithinIdpPeriodError(error) {
  if (!error || !error.response) {
    return false;
  }

  const { response } = error;
  const status = response.status || response.code;
  const message = response.message || '';

  return Number(status) === 500 &&
    message === NO_PROGRESS_TEST_RESULTS_WITHIN_IDP_PERIOD_MESSAGE;
}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/generateErrors.js